export interface Business {
  id: string;
  name: string;
  category: string;
  categorySlug: string;
  district: string;
  address: string;
  phone: string;
  whatsapp: string;
  website?: string;
  instagram?: string;
  rating: number;
  reviewCount: number;
  isOpen: boolean;
  isFeatured: boolean;
  isSponsored: boolean;
  coverImage: string;
  logo: string;
  description: string;
  tags: string[];
  priceRange: string;
  workingHours: {day: string;hours: string;}[];
  services: string[];
  features: string[];
}

export interface Event {
  id: string;
  title: string;
  date: string;
  endDate?: string;
  time: string;
  venue: string;
  district: string;
  category: string;
  price: string;
  isFree: boolean;
  image: string;
  description: string;
  organizer: string;
}

export interface Deal {
  id: string;
  businessId: string;
  businessName: string;
  title: string;
  description: string;
  discount: string;
  originalPrice?: string;
  discountedPrice?: string;
  couponCode: string;
  expiryDate: string;
  image: string;
  category: string;
}

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
  isFeatured: boolean;
  tags: string[];
}

export const CATEGORIES = [
{ slug: 'restoran', label: 'Restoran', icon: 'ForkKnifeIcon', emoji: '🍽️' },
{ slug: 'kafe', label: 'Kafe', icon: 'CoffeeIcon', emoji: '☕' },
{ slug: 'etkinlik', label: 'Etkinlik', icon: 'CalendarIcon', emoji: '🎭' },
{ slug: 'alisveris', label: 'Alışveriş', icon: 'ShoppingBagIcon', emoji: '🛍️' },
{ slug: 'saglik', label: 'Sağlık', icon: 'HeartIcon', emoji: '🏥' },
{ slug: 'egitim', label: 'Eğitim', icon: 'BookOpenIcon', emoji: '📚' },
{ slug: 'hizmetler', label: 'Hizmetler', icon: 'WrenchScrewdriverIcon', emoji: '🔧' },
{ slug: 'konaklama', label: 'Konaklama', icon: 'BuildingOfficeIcon', emoji: '🏨' },
{ slug: 'guzellik', label: 'Güzellik', icon: 'SparklesIcon', emoji: '✨' },
{ slug: 'spor', label: 'Spor', icon: 'TrophyIcon', emoji: '⚽' },
{ slug: 'kultur', label: 'Kültür', icon: 'MuseumIcon', emoji: '🏛️' },
{ slug: 'ulasim', label: 'Ulaşım', icon: 'TruckIcon', emoji: '🚗' }];


export const DISTRICTS = ['Selçuklu', 'Meram', 'Karatay'];

export const businesses: Business[] = [
{
  id: '1',
  name: 'Etli Ekmek Ustası',
  category: 'Restoran',
  categorySlug: 'restoran',
  district: 'Selçuklu',
  address: 'Musalla Bağları Mah. Atatürk Cad. No:42, Selçuklu',
  phone: '+90 332 123 45 67',
  whatsapp: '905321234567',
  website: 'https://etliekmekustasi.com',
  instagram: '@etliekmekustasi',
  rating: 4.8,
  reviewCount: 342,
  isOpen: true,
  isFeatured: true,
  isSponsored: true,
  coverImage: "https://img.rocket.new/generatedImages/rocket_gen_img_441d8ca33-1791053642538.png",
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_441d8ca33-1791053642538.png",
  description: 'Konya\'nın en geleneksel etli ekmek lezzetini 1985\'ten bu yana sunuyoruz. Özel fırınımızda pişirilen etli ekmeklerimiz, seçkin malzemeler ve ustalık gerektiren tarif ile hazırlanmaktadır.',
  tags: ['Etli Ekmek', 'Fırın Kebabı', 'Konya Mutfağı', 'Geleneksel'],
  priceRange: '₺₺',
  workingHours: [
  { day: 'Pazartesi - Cuma', hours: '10:00 - 22:00' },
  { day: 'Cumartesi', hours: '09:00 - 23:00' },
  { day: 'Pazar', hours: '10:00 - 21:00' }],

  services: ['Etli Ekmek', 'Fırın Kebabı', 'Bamya Çorbası', 'Tatlılar', 'Paket Servis'],
  features: ['Otopark', 'Aile Dostu', 'Paket Servis', 'Kredi Kartı']
},
{
  id: '2',
  name: 'Mevlana Kafe & Pastane',
  category: 'Kafe',
  categorySlug: 'kafe',
  district: 'Karatay',
  address: 'Aziziye Mah. Mevlana Cad. No:15, Karatay',
  phone: '+90 332 234 56 78',
  whatsapp: '905322345678',
  instagram: '@mevlanakafe',
  rating: 4.6,
  reviewCount: 218,
  isOpen: true,
  isFeatured: true,
  isSponsored: true,
  coverImage: "https://img.rocket.new/generatedImages/rocket_gen_img_15df57847-1784244944536.png",
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_15df57847-1784244944536.png",
  description: 'Mevlana Müzesi\'ne yürüme mesafesinde, tarihi atmosferde kahve ve tatlı keyfi. Mevlana şekeri ve özel Türk kahvemizle misafirlerimizi ağırlıyoruz.',
  tags: ['Türk Kahvesi', 'Mevlana Şekeri', 'Pasta', 'Tarihi Mekan'],
  priceRange: '₺₺',
  workingHours: [
  { day: 'Her Gün', hours: '08:00 - 23:00' }],

  services: ['Türk Kahvesi', 'Mevlana Şekeri', 'Pasta', 'Sandviç', 'Kahvaltı'],
  features: ['Wi-Fi', 'Aile Dostu', 'Kart Ödeme', 'Dış Mekan']
},
{
  id: '3',
  name: 'Karatay Güzellik Merkezi',
  category: 'Güzellik',
  categorySlug: 'guzellik',
  district: 'Karatay',
  address: 'Karatay Mah. Bedesten Sok. No:8, Karatay',
  phone: '+90 332 345 67 89',
  whatsapp: '905323456789',
  instagram: '@karatayguzellik',
  rating: 4.7,
  reviewCount: 156,
  isOpen: false,
  isFeatured: true,
  isSponsored: false,
  coverImage: "https://img.rocket.new/generatedImages/rocket_gen_img_10dc8a91f-1768304239143.png",
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_10dc8a91f-1768304239143.png",
  description: 'Profesyonel ekibimiz ile cilt bakımı, saç tasarımı ve güzellik hizmetleri sunuyoruz. Modern ekipmanlar ve doğal ürünler kullanıyoruz.',
  tags: ['Cilt Bakımı', 'Saç Tasarımı', 'Manikür', 'Pedikür'],
  priceRange: '₺₺₺',
  workingHours: [
  { day: 'Pazartesi - Cumartesi', hours: '09:00 - 20:00' },
  { day: 'Pazar', hours: 'Kapalı' }],

  services: ['Cilt Bakımı', 'Saç Kesim', 'Boyama', 'Manikür', 'Pedikür', 'Kaş Tasarımı'],
  features: ['Randevu Sistemi', 'Kart Ödeme', 'Klima']
},
{
  id: '4',
  name: 'Selçuklu Spor Salonu',
  category: 'Spor',
  categorySlug: 'spor',
  district: 'Selçuklu',
  address: 'Bosna Hersek Mah. Spor Cad. No:21, Selçuklu',
  phone: '+90 332 456 78 90',
  whatsapp: '905324567890',
  instagram: '@selcukluspor',
  rating: 4.5,
  reviewCount: 89,
  isOpen: true,
  isFeatured: false,
  isSponsored: true,
  coverImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1fb7ecbbc-1773062857732.png",
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1fb7ecbbc-1773062857732.png",
  description: 'Modern fitness ekipmanları, kişisel antrenörler ve grup dersleriyle sağlıklı yaşam yolculuğunuzda yanınızdayız.',
  tags: ['Fitness', 'Yoga', 'Pilates', 'Kişisel Antrenör'],
  priceRange: '₺₺',
  workingHours: [
  { day: 'Pazartesi - Cuma', hours: '06:00 - 23:00' },
  { day: 'Hafta Sonu', hours: '08:00 - 22:00' }],

  services: ['Fitness', 'Yoga', 'Pilates', 'Spinning', 'Kişisel Antrenör'],
  features: ['Otopark', 'Duş', 'Kart Ödeme', 'Klima']
},
{
  id: '5',
  name: 'Meram Konak Otel',
  category: 'Konaklama',
  categorySlug: 'konaklama',
  district: 'Meram',
  address: 'Meram Bağları Mah. Konak Sok. No:5, Meram',
  phone: '+90 332 567 89 01',
  whatsapp: '905325678901',
  website: 'https://meramkonak.com',
  instagram: '@meramkonak',
  rating: 4.9,
  reviewCount: 467,
  isOpen: true,
  isFeatured: true,
  isSponsored: true,
  coverImage: "https://img.rocket.new/generatedImages/rocket_gen_img_482b92853-1791053642675.png",
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_482b92853-1791053642675.png",
  description: 'Meram\'ın yeşil doğası içinde, geleneksel Osmanlı mimarisini modern konforla buluşturan butik otelimiz. Şehir merkezine 10 dakika mesafede.',
  tags: ['Butik Otel', 'Osmanlı Mimarisi', 'Bahçe', 'Kahvaltı'],
  priceRange: '₺₺₺',
  workingHours: [
  { day: 'Resepsiyon', hours: '24 Saat Açık' }],

  services: ['Konaklama', 'Kahvaltı', 'Toplantı Salonu', 'Bahçe', 'Otopark'],
  features: ['Wi-Fi', 'Otopark', 'Klima', 'Aile Dostu', 'Kart Ödeme']
},
{
  id: '6',
  name: 'Konya Dil Okulu',
  category: 'Eğitim',
  categorySlug: 'egitim',
  district: 'Selçuklu',
  address: 'Horozluhan Mah. Eğitim Cad. No:33, Selçuklu',
  phone: '+90 332 678 90 12',
  whatsapp: '905326789012',
  website: 'https://konyadilokulu.com',
  rating: 4.4,
  reviewCount: 73,
  isOpen: true,
  isFeatured: false,
  isSponsored: false,
  coverImage: "https://img.rocket.new/generatedImages/rocket_gen_img_167c99706-1768637181298.png",
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_167c99706-1768637181298.png",
  description: 'İngilizce, Almanca, Arapça ve daha fazlası için uzman kadromuzla yüz yüze ve online dil kursları sunuyoruz.',
  tags: ['İngilizce', 'Almanca', 'Arapça', 'Online Kurs'],
  priceRange: '₺₺',
  workingHours: [
  { day: 'Pazartesi - Cuma', hours: '09:00 - 21:00' },
  { day: 'Cumartesi', hours: '09:00 - 17:00' }],

  services: ['İngilizce', 'Almanca', 'Arapça', 'Fransızca', 'Online Kurs', 'Özel Ders'],
  features: ['Wi-Fi', 'Klima', 'Kart Ödeme']
},
{
  id: '7',
  name: 'Sille Antika & Sanat',
  category: 'Alışveriş',
  categorySlug: 'alisveris',
  district: 'Meram',
  address: 'Sille Köyü Çarşı Mah. No:12, Meram',
  phone: '+90 332 789 01 23',
  whatsapp: '905327890123',
  instagram: '@silleantika',
  rating: 4.6,
  reviewCount: 94,
  isOpen: true,
  isFeatured: false,
  isSponsored: false,
  coverImage: "https://img.rocket.new/generatedImages/rocket_gen_img_44a0a0ec9-1791053644968.png",
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_44a0a0ec9-1791053644968.png",
  description: 'Sille\'nin tarihi çarşısında antika eşyalar, el sanatları ve yerel sanat eserleri. Her parçanın bir hikayesi var.',
  tags: ['Antika', 'El Sanatları', 'Sanat', 'Koleksiyon'],
  priceRange: '₺₺₺',
  workingHours: [
  { day: 'Salı - Pazar', hours: '10:00 - 19:00' },
  { day: 'Pazartesi', hours: 'Kapalı' }],

  services: ['Antika Satış', 'Değerlendirme', 'Restorasyon', 'El Sanatları'],
  features: ['Kart Ödeme', 'Kargo']
},
{
  id: '8',
  name: 'Konya Medikal Klinik',
  category: 'Sağlık',
  categorySlug: 'saglik',
  district: 'Selçuklu',
  address: 'Selçuklu Mah. Sağlık Sok. No:7, Selçuklu',
  phone: '+90 332 890 12 34',
  whatsapp: '905328901234',
  website: 'https://konyamedikal.com',
  rating: 4.7,
  reviewCount: 201,
  isOpen: true,
  isFeatured: false,
  isSponsored: true,
  coverImage: "https://img.rocket.new/generatedImages/rocket_gen_img_43a3b8716-1791053643169.png",
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_43a3b8716-1791053643169.png",
  description: 'Uzman hekimlerimiz ve modern teknolojimizle birinci basamak sağlık hizmetleri, check-up ve poliklinik hizmetleri sunuyoruz.',
  tags: ['Poliklinik', 'Check-up', 'Muayene', 'Laboratuvar'],
  priceRange: '₺₺₺',
  workingHours: [
  { day: 'Pazartesi - Cumartesi', hours: '08:00 - 20:00' },
  { day: 'Pazar', hours: '09:00 - 17:00' }],

  services: ['Dahiliye', 'Genel Cerrahi', 'Ortopedi', 'Dermatoloji', 'Check-up', 'Laboratuvar'],
  features: ['Otopark', 'Engelli Erişim', 'Kart Ödeme']
},
{
  id: '9',
  name: 'Bedesten Çarşısı',
  category: 'Alışveriş',
  categorySlug: 'alisveris',
  district: 'Karatay',
  address: 'Bedesten, Karatay/Konya',
  phone: '+90 332 901 23 45',
  whatsapp: '905329012345',
  instagram: '@bedestenkonya',
  rating: 4.5,
  reviewCount: 312,
  isOpen: true,
  isFeatured: true,
  isSponsored: false,
  coverImage: "https://img.rocket.new/generatedImages/rocket_gen_img_488c680fc-1791053643316.png",
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_488c680fc-1791053643316.png",
  description: 'Tarihi Bedesten\'de yüzlerce yıllık ticaret geleneği sürmektedir. El sanatlarından hediyelik eşyaya, baharattan tekstile geniş ürün yelpazesi.',
  tags: ['Tarihi Çarşı', 'El Sanatları', 'Hediyelik', 'Baharat'],
  priceRange: '₺',
  workingHours: [
  { day: 'Her Gün', hours: '09:00 - 19:00' }],

  services: ['El Sanatları', 'Hediyelik Eşya', 'Baharat', 'Tekstil', 'Takı'],
  features: ['Aile Dostu', 'Engelli Erişim']
},
{
  id: '10',
  name: 'Alaaddin Fırın Kebabı',
  category: 'Restoran',
  categorySlug: 'restoran',
  district: 'Karatay',
  address: 'Alaaddin Mah. Alaaddin Tepesi Cad. No:3, Karatay',
  phone: '+90 332 012 34 56',
  whatsapp: '905330123456',
  rating: 4.9,
  reviewCount: 589,
  isOpen: true,
  isFeatured: true,
  isSponsored: true,
  coverImage: "https://img.rocket.new/generatedImages/rocket_gen_img_43b41507e-1791053644955.png",
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_43b41507e-1791053644955.png",
  description: 'Alaaddin Tepesi\'nin eteğinde, 50 yıllık geleneksel fırın kebabı lezzeti. Sabah erken saatlerde fırına giren etler, öğle vakti hazır olur.',
  tags: ['Fırın Kebabı', 'Konya Mutfağı', 'Geleneksel', 'Tarihi Mekan'],
  priceRange: '₺₺',
  workingHours: [
  { day: 'Her Gün', hours: '11:00 - 20:00 (Tükenene Kadar)' }],

  services: ['Fırın Kebabı', 'Pilav', 'Ayran', 'Paket Servis'],
  features: ['Aile Dostu', 'Nakit/Kart']
},
{
  id: '11',
  name: 'Konya Tur & Gezi',
  category: 'Hizmetler',
  categorySlug: 'hizmetler',
  district: 'Selçuklu',
  address: 'Mevlana Mah. Turizm Cad. No:18, Selçuklu',
  phone: '+90 332 111 22 33',
  whatsapp: '905331112233',
  website: 'https://konyatur.com',
  instagram: '@konyatur',
  rating: 4.8,
  reviewCount: 127,
  isOpen: true,
  isFeatured: false,
  isSponsored: false,
  coverImage: "https://img.rocket.new/generatedImages/rocket_gen_img_409f4264c-1791053643279.png",
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_409f4264c-1791053643279.png",
  description: 'Konya\'nın tarihi ve kültürel zenginliklerini keşfetmek için profesyonel rehberli turlar. Mevlana Müzesi, Alaaddin Tepesi, Sille ve daha fazlası.',
  tags: ['Şehir Turu', 'Rehberli Tur', 'Kültür', 'Tarih'],
  priceRange: '₺₺',
  workingHours: [
  { day: 'Her Gün', hours: '08:00 - 20:00' }],

  services: ['Şehir Turu', 'Özel Tur', 'Havalimanı Transfer', 'Rehberlik'],
  features: ['Çok Dilli', 'Kart Ödeme', 'Online Rezervasyon']
},
{
  id: '12',
  name: 'Selimiye Kültür Evi',
  category: 'Kültür',
  categorySlug: 'kultur',
  district: 'Meram',
  address: 'Selimiye Mah. Kültür Sok. No:9, Meram',
  phone: '+90 332 222 33 44',
  whatsapp: '905332223344',
  instagram: '@selimiyekultur',
  rating: 4.7,
  reviewCount: 85,
  isOpen: true,
  isFeatured: false,
  isSponsored: false,
  coverImage: "https://img.rocket.new/generatedImages/rocket_gen_img_4f4ee6dd6-1791053644956.png",
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_4f4ee6dd6-1791053644956.png",
  description: 'Konya\'nın kültürel mirasını yaşatan sergi, konser ve atölye çalışmaları. Sema gösterileri ve geleneksel el sanatları dersleri.',
  tags: ['Sema', 'El Sanatları', 'Sergi', 'Konser'],
  priceRange: '₺',
  workingHours: [
  { day: 'Salı - Pazar', hours: '10:00 - 22:00' },
  { day: 'Pazartesi', hours: 'Kapalı' }],

  services: ['Sema Gösterisi', 'El Sanatları Atölyesi', 'Sergi', 'Konser', 'Çay Bahçesi'],
  features: ['Engelli Erişim', 'Otopark', 'Aile Dostu']
}];


export const events: Event[] = [
{
  id: 'e1',
  title: 'Şeb-i Arus 2026 Töreni',
  date: '2026-12-17',
  time: '19:00',
  venue: 'Mevlana Kültür Merkezi',
  district: 'Karatay',
  category: 'Kültür',
  price: 'Ücretsiz',
  isFree: true,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4b4d3a786-1791053644623.png",
  description: 'Hz. Mevlana\'nın vefatının yıl dönümü olan Şeb-i Arus\'ta sema töreni ve kültürel etkinlikler.',
  organizer: 'Konya Büyükşehir Belediyesi'
},
{
  id: 'e2',
  title: 'Konya Gastronomi Festivali',
  date: '2026-10-15',
  endDate: '2026-10-18',
  time: '11:00',
  venue: 'Alaaddin Tepesi Meydanı',
  district: 'Karatay',
  category: 'Yemek',
  price: '₺50',
  isFree: false,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4f251b7f1-1791053643316.png",
  description: 'Konya mutfağının en seçkin lezzetleri: etli ekmek, fırın kebabı, bamya çorbası ve daha fazlası.',
  organizer: 'Konya Ticaret Odası'
},
{
  id: 'e3',
  title: 'Sille Antika & El Sanatları Pazarı',
  date: '2026-10-10',
  time: '09:00',
  venue: 'Sille Köyü Meydanı',
  district: 'Meram',
  category: 'Sanat',
  price: 'Ücretsiz',
  isFree: true,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_49a336d5a-1791053644237.png",
  description: 'Sille\'nin tarihi meydanında antika eşyalar, el sanatları ve yerel ürünler.',
  organizer: 'Sille Kültür Derneği'
},
{
  id: 'e4',
  title: 'Karatay Medresesi Gece Turu',
  date: '2026-10-20',
  time: '20:00',
  venue: 'Karatay Medresesi',
  district: 'Karatay',
  category: 'Tarih',
  price: '₺75',
  isFree: false,
  image: "https://images.unsplash.com/photo-1702938363835-7eca3e4baf53",
  description: 'Tarihi Karatay Medresesi\'nde uzman rehber eşliğinde ışıklı gece turu.',
  organizer: 'Konya Tur & Gezi'
},
{
  id: 'e5',
  title: 'Konya Uluslararası Müzik Festivali',
  date: '2026-10-25',
  endDate: '2026-10-27',
  time: '18:00',
  venue: 'Büyükşehir Açık Hava Tiyatrosu',
  district: 'Selçuklu',
  category: 'Müzik',
  price: '₺100',
  isFree: false,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1873fea27-1767878859873.png",
  description: 'Türk ve uluslararası sanatçıların sahne aldığı 3 günlük müzik festivali.',
  organizer: 'Konya Büyükşehir Belediyesi'
},
{
  id: 'e6',
  title: 'Yerel Üreticiler Pazarı',
  date: '2026-10-12',
  time: '08:00',
  venue: 'Meram Bahçeleri',
  district: 'Meram',
  category: 'Pazar',
  price: 'Ücretsiz',
  isFree: true,
  image: "https://images.unsplash.com/photo-1652966023516-e8938cb2ee22",
  description: 'Konya\'nın yerel üreticilerinden taze sebze, meyve, peynir ve ev yapımı ürünler.',
  organizer: 'Meram Belediyesi'
},
{
  id: 'e7',
  title: 'Anadolu Fotoğraf Sergisi',
  date: '2026-10-08',
  endDate: '2026-10-31',
  time: '10:00',
  venue: 'Selimiye Kültür Evi',
  district: 'Meram',
  category: 'Sanat',
  price: 'Ücretsiz',
  isFree: true,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4e673cfe6-1791053645802.png",
  description: 'Anadolu\'nun dört mevsimini belgeleyen 50 fotoğrafçının eserlerinden oluşan sergi.',
  organizer: 'Konya Fotoğraf Derneği'
},
{
  id: 'e8',
  title: 'Konya Kitap Fuarı',
  date: '2026-11-01',
  endDate: '2026-11-10',
  time: '10:00',
  venue: 'Konya Fuar Merkezi',
  district: 'Selçuklu',
  category: 'Eğitim',
  price: 'Ücretsiz',
  isFree: true,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_45a9db9a2-1791053643372.png",
  description: 'Türkiye\'nin önde gelen yayınevleri ve yazarlarının katılımıyla 10 günlük kitap fuarı.',
  organizer: 'Konya Büyükşehir Belediyesi'
}];


export const deals: Deal[] = [
{
  id: 'd1',
  businessId: '1',
  businessName: 'Etli Ekmek Ustası',
  title: '2 Etli Ekmek + 2 Ayran',
  description: 'Konya\'nın efsane etli ekmeğinden 2 adet + 2 ayran kombinasyonu',
  discount: '%25',
  originalPrice: '₺160',
  discountedPrice: '₺120',
  couponCode: 'ETLI25',
  expiryDate: '2026-10-06',
  image: "https://images.unsplash.com/photo-1593007915984-76f8d9d43b4c",
  category: 'Restoran'
},
{
  id: 'd2',
  businessId: '2',
  businessName: 'Mevlana Kafe',
  title: 'Kahvaltı Tabağı + Türk Kahvesi',
  description: 'Serpme kahvaltı tabağı ve özel Türk kahvesi',
  discount: '%20',
  originalPrice: '₺200',
  discountedPrice: '₺160',
  couponCode: 'MEVLANA20',
  expiryDate: '2026-10-10',
  image: "https://images.unsplash.com/photo-1580069491658-8220b0e8722d",
  category: 'Kafe'
},
{
  id: 'd3',
  businessId: '3',
  businessName: 'Karatay Güzellik Merkezi',
  title: 'Cilt Bakımı + Kaş Tasarımı',
  description: 'Profesyonel cilt bakımı ve kaş tasarımı paketi',
  discount: '%30',
  originalPrice: '₺450',
  discountedPrice: '₺315',
  couponCode: 'GUZELLIK30',
  expiryDate: '2026-10-08',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1539f012c-1773188179836.png",
  category: 'Güzellik'
},
{
  id: 'd4',
  businessId: '4',
  businessName: 'Selçuklu Spor Salonu',
  title: '1 Aylık Üyelik',
  description: 'Tüm ders ve ekipman erişimi dahil 1 aylık üyelik',
  discount: '%40',
  originalPrice: '₺600',
  discountedPrice: '₺360',
  couponCode: 'SPOR40',
  expiryDate: '2026-10-15',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4158a48db-1791053643995.png",
  category: 'Spor'
},
{
  id: 'd5',
  businessId: '5',
  businessName: 'Meram Konak Otel',
  title: '2 Gece Konaklama + Kahvaltı',
  description: 'Çift kişilik oda, 2 gece konaklama ve dahil kahvaltı',
  discount: '%15',
  originalPrice: '₺1.800',
  discountedPrice: '₺1.530',
  couponCode: 'KONAK15',
  expiryDate: '2026-10-31',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c90f7532-1769002386409.png",
  category: 'Konaklama'
},
{
  id: 'd6',
  businessId: '11',
  businessName: 'Konya Tur & Gezi',
  title: 'Yarım Günlük Şehir Turu',
  description: 'Mevlana Müzesi, Alaaddin Tepesi ve Karatay Medresesi turu',
  discount: '%20',
  originalPrice: '₺250',
  discountedPrice: '₺200',
  couponCode: 'KOTUR20',
  expiryDate: '2026-11-30',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_46cbde627-1791053644014.png",
  category: 'Hizmetler'
}];


export const articles: Article[] = [
{
  id: 'a1',
  title: 'Konya Mutfağının Efsane Lezzetleri: Etli Ekmekten Bamya Çorbasına',
  excerpt: 'Konya mutfağı, yüzyıllık gelenekleri ve özgün tarifleriyle Türkiye\'nin en zengin bölgesel mutfaklarından biri. Etli ekmek, fırın kebabı ve bamya çorbası bu mutfağın taçları.',
  content: '',
  category: 'Gastronomi',
  author: 'Ayşe Kaya',
  date: '2026-10-01',
  readTime: '5 dk',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_43a64d813-1791053642251.png",
  isFeatured: true,
  tags: ['Etli Ekmek', 'Fırın Kebabı', 'Bamya Çorbası', 'Konya Mutfağı']
},
{
  id: 'a2',
  title: 'Şeb-i Arus: Hz. Mevlana\'nın Düğün Gecesi',
  excerpt: 'Her yıl Aralık ayında gerçekleştirilen Şeb-i Arus töreni, Konya\'yı dünyanın dört bir yanından gelen ziyaretçilerle buluşturuyor.',
  content: '',
  category: 'Kültür',
  author: 'Mehmet Arslan',
  date: '2026-09-28',
  readTime: '7 dk',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4574b63dd-1791053643292.png",
  isFeatured: false,
  tags: ['Şeb-i Arus', 'Mevlana', 'Sema', 'Kültür']
},
{
  id: 'a3',
  title: 'Sille\'nin Gizli Güzelliği: Tarihi Köyde Bir Gün',
  excerpt: 'Konya\'nın 10 km güneyinde yer alan Sille, Bizans döneminden kalma kiliseleri ve tarihi çarşısıyla zaman yolculuğuna davet ediyor.',
  content: '',
  category: 'Gezi',
  author: 'Zeynep Demir',
  date: '2026-09-25',
  readTime: '6 dk',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4a49654dd-1791053644952.png",
  isFeatured: false,
  tags: ['Sille', 'Tarihi Mekanlar', 'Gezi', 'Fotoğraf']
},
{
  id: 'a4',
  title: 'Alaaddin Tepesi: Şehrin Kalbi',
  excerpt: 'Konya\'nın tam merkezinde yükselen Alaaddin Tepesi, Selçuklu mirasının en görkemli temsilcilerinden biri.',
  content: '',
  category: 'Tarih',
  author: 'Ali Yılmaz',
  date: '2026-09-20',
  readTime: '4 dk',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4c1505bfa-1791053643090.png",
  isFeatured: false,
  tags: ['Alaaddin Tepesi', 'Selçuklu', 'Tarih', 'Mimari']
},
{
  id: 'a5',
  title: 'Mevlana Şekeri: Konya\'nın Tatlı Mirası',
  excerpt: 'Asırlık bir gelenek olan Mevlana şekeri, Konya\'nın en özgün hediyelik eşyası olmaya devam ediyor.',
  content: '',
  category: 'Gastronomi',
  author: 'Fatma Öztürk',
  date: '2026-09-15',
  readTime: '3 dk',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_468a07da4-1791053643496.png",
  isFeatured: false,
  tags: ['Mevlana Şekeri', 'Tatlı', 'Gelenek', 'Hediyelik']
},
{
  id: 'a6',
  title: 'Karatay Medresesi\'nin Çini Sanatı',
  excerpt: 'XIII. yüzyıldan kalma Karatay Medresesi, Anadolu Selçuklu çini sanatının en muhteşem örneklerini barındırıyor.',
  content: '',
  category: 'Sanat',
  author: 'Hasan Çelik',
  date: '2026-09-10',
  readTime: '5 dk',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_19108070b-1766331536177.png",
  isFeatured: false,
  tags: ['Karatay Medresesi', 'Çini', 'Selçuklu', 'Sanat']
}];


export const testimonials = [
{
  id: 't1',
  name: 'Serkan Bozkurt',
  business: 'Etli Ekmek Ustası',
  role: 'İşletme Sahibi',
  text: 'MyKonya sayesinde müşteri tabanımız %40 genişledi. Sosyal medya paylaşımları ve rehberdeki konumumuz gerçekten işe yarıyor.',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f6da1e91-1775103557447.png",
  rating: 5
},
{
  id: 't2',
  name: 'Nilüfer Şahin',
  business: 'Karatay Güzellik Merkezi',
  role: 'Kurucu',
  text: 'Profesyonel tanıtım paketleri sayesinde yeni müşterilere ulaşmak çok kolaylaştı. Raporlama sistemi de çok faydalı.',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1b31ef3f0-1766850379208.png",
  rating: 5
},
{
  id: 't3',
  name: 'Murat Erdoğan',
  business: 'Meram Konak Otel',
  role: 'Genel Müdür',
  text: 'Konya\'ya gelen turistler MyKonya üzerinden bize ulaşıyor. Platform gerçekten şehir tanıtımına büyük katkı sağlıyor.',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_17d4fb29e-1767788350359.png",
  rating: 5
}];


export const stats = [
{ label: 'Kayıtlı Firma', value: 850, suffix: '+' },
{ label: 'Aylık Görüntülenme', value: 120, suffix: 'K+' },
{ label: 'Sosyal Medya Takipçisi', value: 45, suffix: 'K+' },
{ label: 'Aktif Etkinlik', value: 32, suffix: '+' }];